document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.underline-reveal');
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target); // odpala tylko raz
      }
    });
  }, {
    threshold: 0.4
  });

  elements.forEach(el => observer.observe(el));
});
